import { lazyWithPreload } from '@kk/shared/utils/async';
import type { ExtendedRouteObject } from '@/routes/types';
import AnnualStatementsPage from './index';
import loader, { type LoaderData, type Params } from './loader';

const AnnualStatements = lazyWithPreload(
  () => import('./AnnualStatements/AnnualStatements'),
);

export default {
  id: 'annual-statements',
  path: '/annualstatements/',
  loader,
  element: <AnnualStatementsPage />,
  children: [
    {
      id: 'statements',
      index: true,
      element: <AnnualStatements />,
    },
  ],
} as const satisfies ExtendedRouteObject<Params, LoaderData>;
